var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2352 5.34112L53.6589 14.7648C55.8005 16.9088 57.0024 19.8159 57 22.8463V36.1537C57.0024 39.1841 55.8005 42.0912 53.6589 44.2352L44.2352 53.6589C42.0912 55.8005 39.1841 57.0024 36.1537 57H22.8463C19.8159 57.0024 16.9088 55.8005 14.7648 53.6589L5.34112 44.2352C3.19951 42.0912 1.99762 39.1841 2 36.1537V22.8463C1.99762 19.8159 3.19951 16.9088 5.34112 14.7648L14.7648 5.34112C16.9088 3.19951 19.8159 1.99762 22.8463 2H36.1537C39.1841 1.99762 42.0912 3.19951 44.2352 5.34112ZM50.2606 40.9226C51.5113 39.6533 52.2005 37.9354 52.1739 36.1537V22.7606C52.1777 21.0085 51.4902 19.3257 50.2606 18.0774L40.9226 8.73936C39.6324 7.4672 37.8792 6.77623 36.068 6.82607H22.7606C21.0085 6.82233 19.3256 7.50984 18.0774 8.73936L8.73936 18.0774C7.48874 19.3467 6.79952 21.0646 6.82607 22.8463V36.2394C6.82233 37.9915 7.50985 39.6743 8.73936 40.9226L18.0774 50.2606C19.3467 51.5113 21.0646 52.2005 22.8463 52.1739H36.2394C37.9915 52.1777 39.6743 51.4901 40.9226 50.2606L50.2606 40.9226Z",
    fill: "#D8052B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2499 16.5C27.2499 15.1193 28.3692 14 29.7499 14C31.1307 14 32.2499 15.1193 32.2499 16.5V30.25C32.2499 31.6307 31.1307 32.75 29.7499 32.75C28.3692 32.75 27.2499 31.6307 27.2499 30.25V16.5Z",
    fill: "#D8052B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 40.25C33.5 42.3211 31.8211 44 29.75 44C27.6789 44 26 42.3211 26 40.25C26 38.1789 27.6789 36.5 29.75 36.5C31.8211 36.5 33.5 38.1789 33.5 40.25Z",
    fill: "#D8052B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorAlert);
export default __webpack_public_path__ + "static/media/error-alert.c62f96ffe6b9b100bd9e4269b16df546.svg";
export { ForwardRef as ReactComponent };